// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const WalletSearchIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "WalletSearch/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m1.025 18.068.633-.633a3.13 3.13 0 0 1-.525-1.742 3.183 3.183 0 0 1 3.184-3.183A3.176 3.176 0 0 1 7.5 15.685a3.183 3.183 0 0 1-3.183 3.183 3.13 3.13 0 0 1-1.742-.525l-.633.633a.65.65 0 0 1-.925 0 .636.636 0 0 1 .008-.908ZM17.917 10.417h-2.084c-.916 0-1.666.75-1.666 1.666 0 .917.75 1.667 1.666 1.667h2.084a.413.413 0 0 0 .416-.417v-2.5a.413.413 0 0 0-.416-.416ZM13.775 4.5c.25.242.042.617-.308.617l-6.9-.009c-.4 0-.6-.483-.317-.766l1.458-1.467a3.164 3.164 0 0 1 4.459 0l1.575 1.592.033.033Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.225 15.55c-.508 1.717-1.975 2.783-3.975 2.783H8.833c-.325 0-.533-.358-.4-.658.25-.583.409-1.242.409-1.842a4.591 4.591 0 0 0-4.584-4.583c-.633 0-1.25.133-1.816.383-.309.134-.684-.075-.684-.408V10c0-2.267 1.367-3.85 3.492-4.117.208-.033.433-.05.667-.05h8.333c.217 0 .425.009.625.042 1.683.192 2.9 1.217 3.35 2.742a.422.422 0 0 1-.4.55h-1.908a2.912 2.912 0 0 0-2.85 3.525C13.342 14.058 14.608 15 16 15h1.825c.292 0 .483.283.4.55Z"
}));
export default WalletSearchIcon;